class StaffController implements ng.IComponentController {
    
    constructor() {
        'ngInject';
    }
}

export const staffComponent = {
    controller: StaffController,
    template: require('./staff.html')
}


// WEBPACK FOOTER //
// ./src/app/modules/settings/staff/staff.component.ts